import { Card, Drawer, Space } from 'antd'
import React, { FC, ReactNode, useCallback } from 'react'

export interface ExplorerDrawerConfigPanelProps {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  width?: number
}

export const ExplorerDrawerConfigPanel: FC<ExplorerDrawerConfigPanelProps> = ({
  open,
  onClose,
  title = 'Panel Configuration',
  children,
  width = 580,
}) => {
  return (
    <Drawer
      title={title}
      placement='right'
      onClose={useCallback(() => onClose(), [onClose])}
      open={open}
      mask
      maskClosable
      width={width}>
      <Space orientation='vertical' size='middle' style={{ width: '100%' }}>
        <Card title='Configuration'>{children}</Card>
      </Space>
    </Drawer>
  )
}
